import { AppName } from '@/models/AppName';
import { Feature } from './Feature';
import { Role } from './Role';

export class Organization {
  label: string;
  name: string;
  userLabel: string;
  tenantId?: number;
  appNames: AppName[];
  configurableAppNames: AppName[];
  features: Feature[];
  roles: Role[];
  constructor(data: any) {
    this.label = data.label || '';
    this.name = data.name || '';
    this.userLabel = data.user_label || '';
    this.tenantId = data.tenant_id;
    this.appNames =
      data.app_names?.map((appName: any) => new AppName(appName)) || [];
    this.configurableAppNames =
      data.configurable_app_names?.map(
        (appName: any) => new AppName(appName)
      ) || [];
    this.features =
      data.features?.map((feature: any) => new Feature(feature)) || [];
    this.roles = data.roles?.map((role: any) => new Role(role)) || [];
  }
}
